/**
 * Per-view data-availability logic, shared by the on-page DashboardTabBar and
 * the sidebar "Dashboards" flyout so the two never drift.
 *
 * Overview and Health always have data (uptime is built-in / URL-based tools /
 * always-on). The rest depend on whether any of their powering integrations are
 * connected.
 */

// Which integrations power each dashboard view.
const TAB_PROVIDERS: Record<string, string[]> = {
  performance: ["ga4", "gsc", "google_ads", "meta_ads", "stackadapt", "callrail", "gbp"],
  acquisition: ["ga4", "gsc", "google_ads", "meta_ads", "stackadapt", "callrail", "hubspot", "hubspot_email"],
  engagement: ["ga4", "callrail"],
  ai: ["ga4", "ai_search_health", "gsc"],
  // Health always has data — uptime is built-in, pagespeed/audits work with just a URL
};

export function tabHasData(
  tab: string,
  providers: Set<string>,
  websiteUrl?: string,
): boolean {
  if (tab === "health") return true; // always has uptime + URL-based tools
  if (tab === "overview") return true;
  if (tab === "ai" && websiteUrl && providers.has("ai_search_health")) return true;
  const required = TAB_PROVIDERS[tab];
  if (!required) return true;
  return required.some((p) => providers.has(p));
}
